module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Spil","flags":["TRACK"],"track":"Play"}}